"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonAppText = void 0;
const styled_1 = __importDefault(require("../../styles/styled"));
const a11y_helpers_1 = require("../../styles/a11y_helpers");
const AppText = styled_1.default.span(props => {
    return Object.assign(Object.assign({ fontSize: props.theme.text.size[props.size], color: props.theme.text.color[props.color] || props.theme.colors.grey90, fontFamily: props.headingFontFamily
            ? props.theme.text.headingFontFamily
            : props.theme.text.bodyFontFamily, fontWeight: getFontWeight(props), textTransform: getTextTransform(props), marginBlockStart: '0px', marginBlockEnd: '0px', lineHeight: props.theme.text.lineHeight[props.size], overflowWrap: props.overflowWrap }, (props.screenReaderOnly ? a11y_helpers_1.screenReaderOnly : {})), props.style);
});
// TODO: remove this component in favor of better button child alignment solution.
exports.ButtonAppText = (0, styled_1.default)(AppText)(props => {
    return {
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        fontcolor: props.color ? props.color : '',
    };
});
exports.ButtonAppText.defaultProps = {
    color: 'dark',
    size: 'medium',
};
function getFontWeight(props) {
    if (props.bold) {
        return 600;
    }
    if (props.semibold || props.headingFontFamily) {
        return 500;
    }
    if (props.light) {
        return 300;
    }
    return 400;
}
function getTextTransform(props) {
    if (props.uppercase) {
        return 'uppercase';
    }
    if (props.capitalize) {
        return 'capitalize';
    }
    return 'none';
}
AppText.defaultProps = {
    color: 'dark',
    size: 'medium',
};
exports.default = AppText;
//# sourceMappingURL=app_text.js.map